export default __webpack_public_path__ + "static/media/live-agro.224b77f8.png";